import {isEmpty} from 'lodash'
import {Suspense, useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../cms/partials'
import FileManager from '../modules/common/components/fileManager/components'
import {ProfileHeader} from '../modules/profileComponent/components/ProfileHeader'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {RouteList} from './RoutesList'
import {IAuthState} from '../../app/modules/auth'
import CheckPermissions from '../modules/common/checkPermission'

export function PrivateRoutes() {
  const module: any = useSelector((state: any) => state.auth.module)
  const auth: IAuthState = useSelector((state: any) => state.auth)
  const [authorizedRoute, setAuthorizedRoute] = useState<Array<string>>([])

  // const hasPermission = auth?.rolePermissions?.permissions.find(
  //   (permission) => permission?.name === `${type} ${activeMenu?.currentActiveMenu}`
  // )

  useEffect(() => {
    if (isEmpty(authorizedRoute)) {
      let newAuthorizedRoute = [...authorizedRoute]
      module?.moduleData?.map((modules: any) =>
        modules.children?.map((route: any) => {
          newAuthorizedRoute?.push(route?.alias)
        })
      )
      setAuthorizedRoute(newAuthorizedRoute)
    }
  }, [module])
  console.log('ROUTE LIST++++++', authorizedRoute, RouteList)
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/media-manager' component={FileManager} />
        <Route path='/profile' component={ProfileHeader} />

        {RouteList?.map(
          (route: any, i: number) =>
            authorizedRoute?.includes(route?.path) && (
              <Route
                path={route?.path}
                key={i}
                exact={route?.exact}
                render={() => {
                  const Component = route.component
                  return (
                    <CheckPermissions type='View'>
                      <Component />
                    </CheckPermissions>
                  )
                }}
              />
            )
        )}

        <Redirect from='/auth' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
      </Switch>
    </Suspense>
  )
}
